/*
 * MDB shim for MDBIcon
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/CreateModal.jsx
 * - src/Components/Custom/InlineTable.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/callPatientCell.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Deliveries/readyToScheduleGrid.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/InventoryProduct/inventoryProductView.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Orders/orderList.jsx
 * - src/Seating/Orders/salesPipelineView.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/PODeliveryUpdate.jsx
 * - src/Seating/PurchaseQueue/ServicePartList.jsx
 * - src/Seating/PurchaseQueue/ShippingDetailsReport.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Reports/accountReport.jsx
 * - src/Seating/Reports/activityReport.jsx
 * - src/Seating/Reports/approvalReport.jsx
 * - src/Seating/Reports/complaintReport.jsx
 * - src/Seating/Reports/deliveryReport.jsx
 * - src/Seating/Reports/expensesReport.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Reports/salesReport.jsx
 * - src/Seating/Reports/serviceOrderReasonReport.jsx
 * - src/Seating/Reports/servicesReport.jsx
 * - src/Seating/Settings/addDeliveryAcknowledgement.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Settings/productMatrixEntry.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Tasks/taskTable.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userEdit.jsx
 * - src/Seating/Users/userList.jsx
 */

export default function MDBIcon({ icon, className = "", ...rest }) {
    const iconClassName = icon ? `fa fa-${icon}` : "fa";

    return <i className={`${iconClassName} ${className}`.trim()} {...rest} />;
}
